export default "__VITE_PUBLIC_ASSET__e963514e__"